import ChangeSubjectArchival from '@Application/Subjects/Archivals/Commands/ChangeSubjectArchival';
import changeSubjectArchival from '@Application/Subjects/Archivals/changeSubjectArchival';
import SubjectAddress from '@Domain/Subjects/SubjectAddress';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import subjectToArchiveSignal, {
	closeSubjectToArchive,
} from '@UI/Pages/Subjects/Signals/subjectToArchiveSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { useDispatch } from '@verclam/synapse';
import { ConfirmDialog } from '@verclam/ui-kit';

type Props = {
	readonly facilityId: number;
	readonly typeKey: string;
};

/** Reversible confirmation of the archival change of the dossier open on the page; the archival function reads the dossier back. */
const SubjectArchivalConfirmationDialog: React.FC<Props> = ({ facilityId, typeKey }) => {
	const dispatch = useDispatch();
	const subjectToArchive = useSignalValue(subjectToArchiveSignal);

	const handleHide = React.useCallback(() => {
		closeSubjectToArchive();
	}, []);

	const handleAccept = React.useCallback(() => {
		if (subjectToArchive === null) {
			return;
		}

		const { subjectId, isArchived } = subjectToArchive;

		dispatch(
			changeSubjectArchival(
				new ChangeSubjectArchival(facilityId, new SubjectAddress(typeKey, subjectId), !isArchived),
			),
		).catch(ignoreHandledError);
	}, [subjectToArchive, facilityId, typeKey, dispatch]);

	return (
		<ConfirmDialog
			blockScroll
			closable
			draggable={false}
			visible={subjectToArchive !== null}
			onHide={handleHide}
			header={subjectToArchive?.isArchived ? 'Désarchiver le dossier' : 'Archiver le dossier'}
			message={
				subjectToArchive?.isArchived
					? 'Le dossier redevient modifiable.'
					: "Le dossier passe en lecture seule : plus d'entretien ni de document, mais tout reste consultable. L'opération est réversible."
			}
			acceptLabel={subjectToArchive?.isArchived ? 'Désarchiver' : 'Archiver'}
			accept={handleAccept}
		/>
	);
};

export default SubjectArchivalConfirmationDialog;
